import * as Routes from '../../scripts/routes';

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  FormularioPersonalizadoController = ($http) ->
    vm = @

    # INIT SETUP
    init = () =>
      return

    # METHODS VIEW MODEL
    vm.modalDeletarItem = (fluxo_texto, hashid) ->
      Swal.fire(
        icon:                'warning'
        title:               'Atenção'
        text:                "Para deletar o seguinte formulário: #{fluxo_texto}, é necessário digitar sua senha:"
        input:               'password'
        inputPlaceholder:    'digite aqui sua senha'
        confirmButtonText:   'Deletar'
        confirmButtonColor:  '#f5222d'
        showCloseButton:     true
        showCancelButton:    true
        showLoaderOnConfirm: true
        inputValidator: (value) => 'É necessário preencher a senha' unless value
        preConfirm: (inputValue) ->
          new Promise((resolve, _reject) ->
            $http.delete("/formularios_personalizados/#{hashid}", {params: {password: inputValue}}).then ((result) ->
              resolve(result.status == 200)

              return
            ), (error) ->
              Swal.fire("Erro!", error.data.message, "error")
            return
          )
        allowOutsideClick:   false
      ).then((result) ->
        if result.value == true
          Turbolinks.visit("/formularios_personalizados?message=#{encodeURIComponent('Formulário Removido')}")
      )

      return

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'FormularioPersonalizadoController', FormularioPersonalizadoController

  # ANGULAR INJECT DEPENDENCIES
  FormularioPersonalizadoController.$inject = ['$http']

  # END BLOCK SCRIPT
  return
